import React from 'react';
import { selectPropTypes } from './SelectPropTypes';
const Select = ({
  name,
  required,
  classname,
  options
}) => {
  const renderOptions = options => {
    return options === null || options === void 0 ? void 0 : options.map((el, index) => /*#__PURE__*/React.createElement("option", {
      key: index
    }, el.label));
  };
  return /*#__PURE__*/React.createElement("select", {
    id: name,
    name: name,
    required: required,
    className: classname
  }, options && renderOptions(options));
};
export default Select;